import {
   useGetActiveLeadSource,
   useGetOrganizationCampaignOverview,
} from '@forwardflow/hooks/customHooks/campaign'
import CampaignService from '@forwardflow/services/CampaignService'
import Icon from '@forwardflow/ui/Icons'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { CampaignFilterDetails } from './CampaignFilterDetails'
import { AdvanceTargetingCampaignModal } from '@forwardflow/modals/AdvanceTargetingCampaignModal'
import { NewLeadCampaignModal } from '@forwardflow/modals/NewLeadsCampaignModal'

export const LeadSourceInfo = () => {
   const [estimatedLead, setEstimatedLead] = useState<number>()
   const { title: leadSource } = useParams()
   const { data: campaignOverview, isLoading } =
      useGetOrganizationCampaignOverview(leadSource as string)

   const { data: activeLeadSourceData, isLoading: isActiveLeadSourceLoading } =
      useGetActiveLeadSource(leadSource as string)

   const campaignFilters =
      activeLeadSourceData?.data?.campaignFilters?.eligibleCriteria

   useEffect(() => {
      const fetchEstimatedLeads = async () => {
         if (!campaignFilters) return
         try {
            const estimatedLeadCount =
               await CampaignService.getEstimatedLeadsForCampaign(
                  campaignFilters
               )
            setEstimatedLead(estimatedLeadCount?.count || 0)
         } catch (error) {
            console.error('Error fetching estimated leads:', error)
         }
      }

      fetchEstimatedLeads()
   }, [campaignFilters, isActiveLeadSourceLoading])
   return (
      <div className="w-[465px] bg-primary/10 rounded-lg font-medium">
         <div className="px-10 py-5">Lead Source Info</div>
         {<CampaignFilterDetails />}

         {(!campaignOverview && !isLoading) ||
         ((!estimatedLead || estimatedLead === 0) &&
            (!campaignOverview?.topAreaCodes ||
               campaignOverview?.topAreaCodes.length === 0)) ? (
            <div className="relative px-10 py-5 border-b bg-white/10 border-black/20">
               <p className="text-[12px]">
                  We're still processing your lead data. Some analytics may not
                  be available yet.
               </p>
            </div>
         ) : null}

         {typeof estimatedLead === 'number' && estimatedLead > 0 && (
            <div className="relative px-10 py-5 border-b bg-white/5 border-black/20">
               <p className="mb-6 text-[12px]">Total Estimated leads</p>
               <p className="text-[32px] mb-2">{estimatedLead}</p>
               <p className="text-[14px] text-white/70">Total leads</p>
               <Icon name="Filters" className="absolute right-2 top-5" />
            </div>
         )}

         {campaignOverview?.topAreaCodes &&
            campaignOverview?.topAreaCodes.length > 0 && (
               <div className="relative px-10 pt-5 ">
                  <p className="mb-3 text-[12px]">Top Area Codes</p>

                  <Icon
                     name="Location"
                     className="absolute right-2 top-5 fill-white/20"
                  />
               </div>
            )}
         {campaignOverview?.topAreaCodes
            ?.sort(
               (a: { percentage: number }, b: { percentage: number }) =>
                  b.percentage - a.percentage
            )
            .slice(0, 3)
            .map((locality: { areaCode: string; percentage: number }) => (
               <div
                  key={locality?.areaCode}
                  className="relative px-10 py-5 border-b border-black/20"
               >
                  <div className="text-[32px] mb-2">
                     {locality?.percentage}
                     <span className="text-[24px] mb-2"> %</span>
                  </div>
                  <div className="flex gap-3">
                     <p className="text-[14px] text-white/70">
                        {locality?.areaCode}
                     </p>
                  </div>
               </div>
            ))}
         <AdvanceTargetingCampaignModal />
         <NewLeadCampaignModal />
      </div>
   )
}
